import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { sites } from '@/mocks/sites';
import SectionHeading from '@/components/base/SectionHeading';

export default function CategoryGrid() {
  return (
    <section id="categories" className="scroll-mt-20">
      <SectionHeading
        icon="ri-layout-grid-line"
        title="分类快捷入口"
        subtitle="按行业领域快速浏览，覆盖高频使用场景"
      />
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
        {categories.map((category) => {
          const count = sites.filter((site) => site.categoryId === category.id).length;
          return (
            <Link
              key={category.id}
              to={`/category/${category.id}`}
              className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300 hover:bg-primary-50"
            >
              <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${category.icon} text-lg`}></i>
              </span>
              <span className="min-w-0">
                <span className="block truncate text-sm font-medium text-foreground-900">{category.name}</span>
                <span className="block text-xs text-foreground-400">{count} 个网站</span>
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}